@if (component) {
<div class="_content w-6 va-t"
     [class._hidden]="isNotVisible()">
    <div class="flex flex-column flex-justify-between height-100 overflow-auto"
         [class.p-b-10]="!!parent"
         #scrollable>
        @for (item of component.menu; track $index; let index = $index; let first = $first) {
        <div (click)="menuClick(item, index)"
             class="p-l p-r b-col-5 flex flex-middle cursor-pointer"
             [ngClass]="item.image ? 'p-t p-b' : 'p-t-5 p-b-5'"
             [class.b-b]="item.type !== EMenuItemType.button">
            @if (item.icon && item.type === EMenuItemType.menu) {
            <i class="m-r-2 inline-flex"
               [ngClass]="item.icon"></i>
            }
            @if (item.image && item.type === EMenuItemType.link) {

            <img [ratio]="1"
                 [width]="50"
                 [dfImage]="item.image"
                 class="b-a b-col-51 m-r-2 _radius">

            }
            @if (item.type === EMenuItemType.menu || item.type === EMenuItemType.link) {
            <!-- title -->

            <href [link]="item.type === EMenuItemType.link && item.link">
                <div class="flex-grow w-12 p2"
                     *iCms="'text' of item">
                </div>
            </href>
            <div class="flex-grow"></div>
            }
            <!-- icon -->
            @if (item.type === EMenuItemType.menu) {
            <i class="icon-chevron-right"></i>
            }
            @if(item.type === EMenuItemType.button) {
            <href [link]="item.link">
                <span class="s1"
                      inlineButton
                      *iCms="'text' of item"></span>
            </href>
            }
        </div>
        }
        <ng-content></ng-content>
    </div>
</div>
<div class="_children w-6 va-t">
    @for (item of menusWithChildren; track $index) {
    <div class="_child"
         [toggleClass]="'_active'"
         [toggleClassBy]="toggleService.getState([parentId, item.index])">
        <page-off-canvas-menu [component]="item"
                              [level]="level + 1"
                              [parent]="component"
                              [parentId]="parentId + item.index"></page-off-canvas-menu>
    </div>
    }
</div>
}
